var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Chip, CircularProgress, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { AudienceService } from "../../../services/audience/audience.service";
/**
 * Step 2.9: multi-select picker for `IN_AUDIENCE` / `NOT_IN_AUDIENCE` rules. Loads the org's
 * non-archived audiences via `AudienceService.getAllAudiences` and stores the selected ids
 * in `filterRow.textValues`. Each chip shows the audience name but the persisted value is
 * the audience id, so the rule continues to resolve correctly even if the referenced
 * audience is later renamed.
 *
 * `data-testid="audience-id-input"` on the autocomplete to ease end-to-end QA.
 */
export var FilterAudienceIdInput = function (_a) {
    var filterRow = _a.filterRow, setFilterRow = _a.setFilterRow;
    var t = useTranslation().t;
    // Cache for 5 minutes — the dropdown is shown only briefly per rule.
    var audiencesQ = useQuery(['allAudiencesForIdInput'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var page;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AudienceService.getAllAudiences({
                        archived: false,
                        limit: { limit: 200, offset: 0 },
                    })];
                case 1:
                    page = _a.sent();
                    return [2 /*return*/, page.content || []];
            }
        });
    }); }, { staleTime: 5 * 60 * 1000 });
    var audiences = audiencesQ.data || [];
    var byId = new Map(audiences.map(function (a) { return [a.id || '', a]; }));
    var selectedIds = (filterRow.textValues || []).filter(function (v) { return !!v; });
    var selectedAudiences = selectedIds
        .map(function (id) { return byId.get(id); })
        .filter(function (a) { return !!a; });
    var labelFor = function (a) { return a.name || a.id || ''; };
    return (_jsx(Autocomplete, { multiple: true, size: 'small', "data-testid": 'audience-id-input', options: audiences, loading: audiencesQ.isLoading, getOptionLabel: labelFor, isOptionEqualToValue: function (opt, val) { return opt.id === val.id; }, value: selectedAudiences, onChange: function (_, newValues) {
            setFilterRow(__assign(__assign({}, filterRow), { textValues: newValues.map(function (a) { return a.id; }).filter(function (id) { return !!id; }) }));
        }, renderTags: function (value, getTagProps) {
            return value.map(function (option, index) {
                var _a = getTagProps({ index: index }), key = _a.key, rest = __rest(_a, ["key"]);
                return (_jsx(Chip, __assign({ size: 'small', label: labelFor(option) }, rest), key));
            });
        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { placeholder: t('Select audiences'), InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [audiencesQ.isLoading ? _jsx(CircularProgress, { color: "inherit", size: 16 }) : null, params.InputProps.endAdornment] })) }) }))); }, sx: { minWidth: 280, flex: 1 } }));
};
export default FilterAudienceIdInput;
